const AWAITING_OFFER = "awaitingoffer";
const AWAITING_ACTION = "awaitingaction";

export const resolveTenderStatusFilter = (statuses = []) => {
  const hasAwaitingOffer = statuses.includes(AWAITING_OFFER);
  const hasAwaitingAction = statuses.includes(AWAITING_ACTION);
  const normalizedStatuses = [
    ...new Set(statuses.map((status) => (status === AWAITING_ACTION ? AWAITING_OFFER : status))),
  ];

  let isExpiredTender;

  if (hasAwaitingOffer && hasAwaitingAction) {
    isExpiredTender = null;
  } else if (hasAwaitingAction) {
    isExpiredTender = true;
  } else if (hasAwaitingOffer) {
    isExpiredTender = false;
  }

  return { statuses: normalizedStatuses, isExpiredTender };
};

export const withTenderStatusFilter = (params) => {
  const { statuses, isExpiredTender } = resolveTenderStatusFilter(params.statuses);
  const requestParams = { ...params, statuses };

  delete requestParams.isExpiredTender;

  if (isExpiredTender !== undefined) {
    requestParams.isExpiredTender = isExpiredTender;
  }

  return requestParams;
};
